import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import DragNDropModal from './drag_n_drop_modal';
import InvestmentsChallenge1InitialText from '../../dragNDropText/investment_challenge1_initial_text';
import InvestmentsChallenge1HintsText from './text/investments_challenge1_hints_text';
import InvestmentsChallenge1Dataset from './Datasets/investments_challenge1_dataset';
import InvestmentsChallenge2InitialText from '../../dragNDropText/investment_challenge2_initial_text';
import InvestmentsChallenge2HintsText from './text/investments_challenge2_hints_text';
import InvestmentsChallenge2Dataset from './Datasets/investments_challenge2_dataset';
import { createColumnArray } from '../../objects/DragNDrop/createColumnArray_function';
import { calcColumnScore } from '../../objects/DragNDrop/calcColumnScore_function';
import { dragNDropBefore } from '../../objects/DragNDrop/drag_n_drop_before_function';
import ExtraCreditConfigFile from './Datasets/extra_credit_config_file';

class InvestmentExtraCredit extends Component {
    constructor(props) { 
        super(props);
        this.state = {
            callRender: false,
            openSw: false,
        }
        this.currentStatus = "DisplayChallenge1";
        this.dragNDrop = {};
        this.modalMessage = "";
        this.hintTable = [];
        this.hintNbr = 0;
        this.displayAlert = false;
        this.tableObject = [];
        this.tableNbrRows = 0;
        this.freezeFlag = false;
        this.challenge1Score = 0;
        this.challenge2Score = 0;
        this.avergeScore = 0;
        this.col1Text = "";
    }

    // getting error: "findDOMNode is deprecated and will be removed 
    // in the next major release. Instead, add a ref directly to the element you want to reference"

    openInvestmentsChallenge1() {
        this.currentStatus = "OpenChallenge1";
        this.dragNDrop = dragNDropBefore("Determine If Statements About Investments are True or False?",
            InvestmentsChallenge1InitialText, "", "", "",
            InvestmentsChallenge1Dataset, "InvestmentsChallenge1", 0);
      
        this.hintTable = InvestmentsChallenge1HintsText;     
        this.setState({openSw: true});
    }

    closeInvestmentChallenge1() {
        this.currentStatus = "DisplayChallenge1"
        this.setState({openSw: false});
    }

    saveInvestmentChallenge1() {
        var columnArray=createColumnArray(this.dragNDrop.cookieNamePfx, 2);
        if (columnArray[1].items.length === 0) {
            this.modalMessage = "Drag items from the Statements That are False " +
                "column to the Statements That are True column."
            this.setState({callRender: !this.state.callRender});
        }else{
            this.challenge1Score = calcColumnScore(columnArray);
            if (this.challenge1Score > 90) {
                this.modalMessage = "";
                sessionStorage.setItem("investmentsChallenge1Score", this.challenge1Score);
                this.currentStatus = "DisplayChallenge2";
                this.setState({openSw: false});
            } else {
                this.modalMessage= "Not quite right... Try again.";
                this.displayAlert = true;
                if (this.hintNbr < this.hintTable.length){
                    this.hintNbr += 1;
                }
                this.setState({callRender: !this.state.callRender});
            }    
            
        }
    }
     
    openInvestmentsChallenge2() {
        this.currentStatus = "OpenChallenge2";
        this.modalMessage = "";
        this.dragNDrop = dragNDropBefore("Identify key attributes oft investment types",
            InvestmentsChallenge2InitialText, "", "", "",
            InvestmentsChallenge2Dataset, "InvestmentsChallenge2", 99) 
        this.tableNbrRows = 0;
        this.hintTable = InvestmentsChallenge2HintsText; 
        this.setState({openSw: true});
    }

    closeInvestmentChallenge2() {
       this.currentStatus = "DisplayChallenge2";
       this.freezeFlag = false;
       this.setState({openSw: false});
    }

    saveInvestmentChallenge2() {
        var columnArray=createColumnArray(this.dragNDrop.cookieNamePfx, 3);
        this.challenge2Score = calcColumnScore(columnArray);
        if (this.challenge2Score > 85) {
            this.modalMessage = "";
            this.currentStatus = "DisplayChallenge2";
            this.finishInvestmentsChallenge();
            this.setState({openSw: false});
        } else {
            this.modalMessage= "Not quite right... Try again.";
            this.displayAlert = true
            if (this.hintNbr < this.hintTable.length){
                this.hintNbr+=1;
            }
            this.setState({callRender: true});
        }   
    }

    getInvestmentsChallenge1Score() {
        var challenge1Score = parseFloat(sessionStorage.getItem("investmentsChallenge1Score"));
        if (!isNaN(challenge1Score) && this.currentStatus === "DisplayChallenge1") {
           this.currentStatus = "DisplayChallenge2";
           this.challenge1Score = challenge1Score;
        }
    }
    
    closeAlert(){
        this.displayAlert = false;
        this.setState({callRender: true});
    }
    
    render() {
        this.getInvestmentsChallenge1Score();
       
             
    return <>

        <Modal show={this.props.show}  onHide={() => this.props.onClose()} size="med" scrollable="true">
            <Modal.Header closeButton>
                <Modal.Title>Extra Credit - Investments</Modal.Title> 
            </Modal.Header>
            <Modal.Body>
                {this.currentStatus === "DisplayChallenge1" ?
                     <span>
                        <div className="m-4">
                            <p>One way people can make their money work for them is through investing. 
                               If you have savings that you won’t need in the near future, investing 
                               may be a smart option to consider. However, before you begin investing,
                               it’s important to understand some key concepts. </p>
                               <p></p> 
                               <p>Click on the "Challenge1" button to learn more and check
                               your understanding.</p>
                        </div>
                                                    
                        <div className="text-center">
                            <button className="btn btn-primary w-75 mt-4" 
                            onClick ={()=> this.openInvestmentsChallenge1()}>
                                Investment Challenge #1
                            </button>
                        </div>
                    </span>
                :
                    <div></div>
                }
                {this.currentStatus === "OpenChallenge1" ?
                    <DragNDropModal show={this.state.openSw} 
                        onClose={() => this.closeInvestmentChallenge1()} 
                        onSave={() => this.saveInvestmentChallenge1()}
                        closeAlert={() => this.closeAlert()}
                        inputDataset={this.dragNDrop.inputData}
                        modalSize={this.dragNDrop.modalSize}
                        modalTitle={this.dragNDrop.modalTitle}
                        introText={this.dragNDrop.introText}
                        cookieNamePfx={this.dragNDrop.cookieNamePfx}
                        buttonType={this.dragNDrop.buttonType}
                        message={this.modalMessage}
                        hintTable={this.hintTable}
                        hintNbr={this.hintNbr}
                        displayAlert={this.displayAlert}
                    />
                :
                    <div></div>
                }
           
                {this.currentStatus === "DisplayChallenge2" ?
                    <span>
                         <div className="m-4" >
                             <p>It can be difficult to know what investments are best for you.
                                Click on the "Challenge2" button to see if you can determine 
                                which facts apply to each of the different types of investments
                                that are listed.
                                </p>
                        </div>
                        <div className="text-center">
                            <button className="btn btn-primary w-75 mt-4" 
                            onClick ={()=> this.openInvestmentsChallenge2()}>
                                Investments Challenge #2
                            </button>
                        </div>
                    </span>
                :
                    <div></div>
                }
                {this.currentStatus === "OpenChallenge2" ?
                    <DragNDropModal show={this.state.openSw} 
                        onClose={() => this.closeInvestmentChallenge2()} 
                        onSave={() => this.saveInvestmentChallenge2()}
                        onContinue={() => this.finishChallenge2()}
                        closeAlert={() => this.closeAlert()}
                        inputDataset={this.dragNDrop.inputData}
                        modalSize={this.dragNDrop.modalSize}
                        modalTitle={this.dragNDrop.modalTitle}
                        introText={this.dragNDrop.introText}
                        cookieNamePfx={this.dragNDrop.cookieNamePfx}
                        maxNbr={this.dragNDrop.maxNbrPerColumn}
                        buttonType={this.dragNDrop.buttonType}
                        message={this.modalMessage}
                        tableNbrRows={this.tableNbrRows}
                        tableCol1Text={this.state.col1Text}
                        tableObjectRow={this.tableObject}
                        freezeFlag={this.freezeFlag}
                        hintTable={this.hintTable}
                        hintNbr={this.hintNbr}
                        displayAlert={this.displayAlert}
                        />
                :
                    <div></div>
                }
            </Modal.Body>
            <Modal.Footer className="text-right">
                <img src="./assets/sidebar_icon.png" className="train_icon_thumbnail_img mr-5"
                    alt="train"/>
                <Button variant="secondary"   onClick={() => this.props.onClose()}>
                    Close
                </Button>
          </Modal.Footer>
          </Modal>             
            
        </>
    }

    finishInvestmentsChallenge() {
        this.averageScore = (+this.challenge1Score +  +this.challenge2Score) / 2; 
        this.calculateInvestmentPoints();
        sessionStorage.setItem("previousExtraCreditProcess", "Investments");
        this.props.onCompleted(); 
    }

    calculateInvestmentPoints(){
        var earnedAmt = 0;
        let processName = "Investments";
        let earningsObj = ExtraCreditConfigFile.exercises.find(elem => elem.category === processName);
        earnedAmt = (+earningsObj.amt).toFixed(2);
        this.averageScore = this.averageScore.toFixed(2);
       
        const investmentsObj = {processName: processName, score: this.averageScore,
            assetType: earningsObj.type, amount: earnedAmt, level: earningsObj.level}
          
        sessionStorage.setItem("extraCreditCompleted", JSON.stringify(investmentsObj));
    }

}


export default InvestmentExtraCredit;